import { useCallback } from "react";

interface Country {
  _id: string;
  name: string;
  code: string;
}

interface PlaceDetails {
  street: string;
  city: string;
  state: string;
  county: string;
  postalCode: string;
  countryCode: string;
  formattedAddress: string;
  latitude?: number | null;
  longitude?: number | null;
}

interface AddressFormData {
  street: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  /** Map location of the picked place — null when Places had no geometry. */
  latitude: number | null;
  longitude: number | null;
}

export const useGooglePlaces = (countries: Country[] = []) => {
  // Find country ID by country code
  const findCountryIdByCode = useCallback(
    (countryCode: string): string => {
      const country = countries.find(
        (c) => c.code?.toLowerCase() === countryCode?.toLowerCase()
      );
      return country?._id || "";
    },
    [countries]
  );

  // Convert Google Places details to form data
  const convertPlaceToFormData = useCallback(
    (placeDetails: PlaceDetails): AddressFormData => {
      return {
        street: placeDetails.street,
        city: placeDetails.city,
        state: placeDetails.state,
        postalCode: placeDetails.postalCode,
        country: findCountryIdByCode(placeDetails.countryCode),
        latitude: placeDetails.latitude ?? null,
        longitude: placeDetails.longitude ?? null,
      };
    },
    [findCountryIdByCode]
  );

  return {
    findCountryIdByCode,
    convertPlaceToFormData,
  };
};
